export default __webpack_public_path__ + "static/media/map-bg@2x.7da05b81.webp";